module.exports = __webpack_public_path__ + "img/icon_map_53_off_011.fcdf18e6.png";